import { ReactSelectOption } from "../../../features/Interfaces";
import { DataEncoding } from "../../../services/types/gallus";

export const DataSourceURL: string =
  "https://docs.google.com/spreadsheets/d/173K9GApryikbBhiw_duzax1nuKMK7rNg/";
export const EmptySelection: ReactSelectOption = { value: "", label: "" };

export enum inputGroupNames {
  PAndLExHUD = "P&LExHUD",
  PAndLHUD = "P&LHUD",
  Headcount = "Headcount",
  NoTitle = "NoTitle",
  Portfolio = "Portfolio",
  WorkingCapital = "WorkingCapital",
  Other = "Other",
}

export const inputGroups: ReactSelectOption[] = [
  { value: inputGroupNames.PAndLExHUD, label: "P&L (ex. HUD)" },
  { value: inputGroupNames.PAndLHUD, label: "P&L (HUD)" },
  { value: inputGroupNames.Headcount, label: "Headcount (ex. HUD)" },
  { value: inputGroupNames.NoTitle, label: "Headcount (HUD)" },
  { value: inputGroupNames.Portfolio, label: "Portfolio" },
  { value: inputGroupNames.WorkingCapital, label: "Working Capital" },
  { value: inputGroupNames.Other, label: "Other" },
];

export enum kpiNames {
  PAndLExHUD = "P&LExHUD",
  PAndLHUD = "P&LHUD",
  PAndLIncHUD = "P&LIncHUD",
  PAndLIncPeer = "P&LIncPeer",
  BSExHUD = "BSExHUD",
  BSIncPeer = "BSIncPeer",
}

//const companyName = "Celink";
const companyName = "Company";

export const plKPIGroups: ReactSelectOption[] = [
  { value: kpiNames.PAndLExHUD, label: companyName + " (ex. HUD)" },
  { value: kpiNames.PAndLHUD, label: companyName + " (HUD)" },
  { value: kpiNames.PAndLIncHUD, label: companyName + " (Inc. HUD)" },
  { value: kpiNames.PAndLIncPeer, label: companyName + " (Inc. Peer)" },
];

export const bsKPIGroups: ReactSelectOption[] = [
  { value: kpiNames.BSExHUD, label: companyName + " (ex. Peer)" },
  { value: kpiNames.BSIncPeer, label: companyName + " (Inc. Peer)" },
];

export interface dataLocation {
  staticValue: number;
  initialDynamicValue: number;
  finalDynamicValue: number;
}

export interface kpiMetadata {
  kpiName: kpiNames;
  chartInfo: chartInfo;
  rowData: dataLocation[];
}

export interface chartInfo {
  chartNames: string[];
  chartFormat: DataEncoding[];
}

export type chartData = number[]; //Equals to the data for one chart

export interface chartGroupData {
  name: kpiNames;
  metadata: chartInfo;
  data: chartData[]; //Equals to the data for one KPI (multiple charts)
}

const PAndLKPIChartNames = [
  "Revenue",
  "Total Opex (Ex. D&A)",
  "EBT",
  "EBT Margin",
];

const BSKPIChartNames = [
  "Assets",
  "Liabilities",
  "Equity",
  "Eq. to Asset Ratio",
];

const formatArray: DataEncoding[] = ["$s", "$s", "$s", "%1d"];

export const pAndLChartMetaData: chartInfo = {
  chartNames: PAndLKPIChartNames,
  chartFormat: formatArray,
};

export const bsChartMetaData: chartInfo = {
  chartNames: BSKPIChartNames,
  chartFormat: formatArray,
};

const PAndLExHUDDataLocation: dataLocation[] = [
  { staticValue: 211, initialDynamicValue: 89, finalDynamicValue: 95 },
  { staticValue: 212, initialDynamicValue: 89, finalDynamicValue: 95 },
  { staticValue: 213, initialDynamicValue: 89, finalDynamicValue: 95 },
  { staticValue: 215, initialDynamicValue: 89, finalDynamicValue: 95 },
];

const PAndLHUDDataLocation: dataLocation[] = [
  { staticValue: 219, initialDynamicValue: 89, finalDynamicValue: 95 },
  { staticValue: 220, initialDynamicValue: 89, finalDynamicValue: 95 },
  { staticValue: 221, initialDynamicValue: 89, finalDynamicValue: 95 },
  { staticValue: 223, initialDynamicValue: 89, finalDynamicValue: 95 },
];

const PAndLIncHUDDataLocation: dataLocation[] = [
  { staticValue: 227, initialDynamicValue: 89, finalDynamicValue: 95 },
  { staticValue: 228, initialDynamicValue: 89, finalDynamicValue: 95 },
  { staticValue: 229, initialDynamicValue: 89, finalDynamicValue: 95 },
  { staticValue: 231, initialDynamicValue: 89, finalDynamicValue: 95 },
];

const PAndLIncPeerDataLocation: dataLocation[] = [
  { staticValue: 235, initialDynamicValue: 89, finalDynamicValue: 95 },
  { staticValue: 236, initialDynamicValue: 89, finalDynamicValue: 95 },
  { staticValue: 237, initialDynamicValue: 89, finalDynamicValue: 95 },
  { staticValue: 239, initialDynamicValue: 89, finalDynamicValue: 95 },
];

const BSExHUDDataLocation: dataLocation[] = [
  { staticValue: 244, initialDynamicValue: 89, finalDynamicValue: 95 },
  { staticValue: 245, initialDynamicValue: 89, finalDynamicValue: 95 },
  { staticValue: 246, initialDynamicValue: 89, finalDynamicValue: 95 },
  { staticValue: 247, initialDynamicValue: 89, finalDynamicValue: 95 },
];

const BSIncPeerDataLocation: dataLocation[] = [
  { staticValue: 251, initialDynamicValue: 89, finalDynamicValue: 95 },
  { staticValue: 252, initialDynamicValue: 89, finalDynamicValue: 95 },
  { staticValue: 253, initialDynamicValue: 89, finalDynamicValue: 95 },
  { staticValue: 254, initialDynamicValue: 89, finalDynamicValue: 95 },
];

export const kpiRowValues: kpiMetadata[] = [
  {
    kpiName: kpiNames.PAndLExHUD,
    rowData: PAndLExHUDDataLocation,
    chartInfo: pAndLChartMetaData,
  },
  {
    kpiName: kpiNames.PAndLHUD,
    rowData: PAndLHUDDataLocation,
    chartInfo: pAndLChartMetaData,
  },
  {
    kpiName: kpiNames.PAndLIncHUD,
    rowData: PAndLIncHUDDataLocation,
    chartInfo: pAndLChartMetaData,
  },
  {
    kpiName: kpiNames.PAndLIncPeer,
    rowData: PAndLIncPeerDataLocation,
    chartInfo: pAndLChartMetaData,
  },
  {
    kpiName: kpiNames.BSExHUD,
    rowData: BSExHUDDataLocation,
    chartInfo: bsChartMetaData,
  },
  {
    kpiName: kpiNames.BSIncPeer,
    rowData: BSIncPeerDataLocation,
    chartInfo: bsChartMetaData,
  },
];

export const yearGroups: ReactSelectOption[] = [
  { value: "2024", label: "2024" },
  { value: "2025", label: "2025" },
  { value: "2026", label: "2026" },
  { value: "2027", label: "2027" },
  { value: "2028", label: "2028" },
  { value: "2029", label: "2029" },
];

export const xAxis: string[] = ["2024", "2025", "2026", "2027", "2028", "2029"];
